// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"09c96bf5","258":"9e5643d3","377":"a0e148dc","453":"a99eb8e6","848":"0c653840"}[chunkId] + ".chunk.js";
};